import { useState, useEffect} from 'react';
import api from '../../../config.js';
import './order.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaSearch, FaArrowLeft, FaArrowRight, FaCog, FaPen, FaEye } from 'react-icons/fa';
import { parseToFloat, showMessageError } from '../../../classes/functions';
import ReactTooltip from "react-tooltip";
import { RiArrowUpDownLine } from 'react-icons/ri';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useHistory } from 'react-router-dom';

export default function OrderPoint(){
  const [list, setList] = useState([]);
  const [listAll, setListAll] = useState([]);
  
  const [page, setPage] = useState(1);
  const [limitPage, setLimitPage] = useState(1);

  const [total, setTotal] = useState('');
  const [itensByPage, setItensByPage] = useState(50);
  const [carrying, setCarrying] = useState(true);
  const [orderBy, setOrderBy] = useState("");
  const [orderDir, setOrderDir] = useState("ASC");
  const [termSearch, setTermSearch] = useState("");
  const [propertiesOfTable, setPropertiesOfTable] = useState(
    [
      {label: "Código", property: "codigo"},
      {label: "Descrição", property: "descricao"},
      {label: "Tipo", property: "tipo"},
      {label: "Grupo", property: "grupo"},
      {label: "Ponto de pedido", property: "ponto_pedido"},
      {label: "Estoque de Segurança", property: "estoque_seguranca"},
      {label: "Lote Econômico", property: "lote_economico"},
      {label: "Saldo", property: "saldo"},
      {label: "Opções"}
    ]
  );

  function getOrderPoint(){
    api.get(`/api/products/getOrderPoint?page=${page}&limit=${itensByPage}&order_by=${orderBy}&order_dir=${orderDir}&search=${termSearch}`)
    .then((response) => {
      setList(response.data.result);
      setListAll(response.data.result);
      setLimitPage(parseInt(response.data.total / itensByPage) + 1);

      setCarrying(false);
    }).catch((error) => {
      console.log(error);
      showMessageError(error.response.data);
    });
  }

  function setOrdering(propertyForOrdering){
    if(orderDir === "ASC"){
      setOrderDir("DESC");
    } else if(orderDir === "DESC"){
      setOrderDir("ASC");
    }

    return setOrderBy(propertyForOrdering);
  }
  
  function search(e) {
    setTermSearch(e.target.value);
  }

  useEffect(() => {
    getOrderPoint();
  }, [, page, itensByPage, orderBy, orderDir, termSearch]);

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Ponto de Pedido">
          <select className='selectQtdeItens' value={itensByPage} onChange={ (e) => setItensByPage(e.target.value) }>
            <option value="50">Itens por página</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
          </select>
          <input className="inputSearch" type="text" onChange={search} placeholder="Pesquisar"/>
          <FaSearch className="iconSearch" style={{color: '#001675' }} size={16}/>
        </Title>

        <div className="container">
          <table>
            <thead>
              <tr>
                {propertiesOfTable.map((property, index) => {
                  if(property.label !== "Opções"){
                    return (
                      <th scope="col" key={index}>
                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                          <p>{property.label}</p>
                          <button onClick={() => setOrdering(property.property)} style={{backgroundColor: 'inherit', fontSize: '1rem', marginLeft: '0.5rem', marginTop: '0.25rem', padding: '0', width: 'inherit', height: 'inherit'}}>
                            <RiArrowUpDownLine onClick={() => {}}  />
                          </button>
                        </div>
                      </th>
                    )
                  }
                  
                  return (
                    <th scope="col" key={index}>Opções</th>
                  )
                })}
              </tr>
            </thead>
            <tbody>
              {list.map((item, index)=>{
                return(
                  <tr key={index}>
                    <td data-label="Código">{item.codigo}</td>
                    <td data-label="Descrição">{item.descricao}</td>
                    <td data-label="Tipo">{item.tipo}</td>
                    <td data-label="Grupo">{item.grupo}</td>
                    <td data-label="Ponto de Pedido">{item.ponto_pedido}</td>
                    <td data-label="Estoque de Segurança">{item.estoque_seguranca}</td>
                    <td data-label="Lote Econômico">{item.lote_economico}</td>
                    <td data-label="Saldo">{parseFloat(item.saldo) ? parseFloat(item.saldo) : 0}</td>
                    <td data-label="Opções">
                      <Link className="action" onClick={() => {window.open(`/products/cadastrar/u${item.id}`, '_blank')}}>
                        <FaPen color="#000" size={17} />
                      </Link>
                      <Link className="action" onClick={() => {window.open(`/products/cadastrar/v${item.id}`, '_blank')}}>
                        <FaEye color="#000" size={19} />
                      </Link>
                    </td>
                  </tr>
                )
              })}
              {list.length == 0 && <tr>
                <td colSpan={6}><label className='required'>Nenhum registro encontrado!</label></td>
              </tr>}
            </tbody>
          </table>
        </div>
        <br/>
        <div className="divGroupPagination">
            <button data-tip="Primeira página" type="button" onClick={() => setPage(1)} className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft  color="#001675" size={17} /></button>
            <button data-tip="Página anterior" type="button" onClick={() => setPage(page > 1 ? page - 1 : 1)} className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
            <div className="divLabelPagination">
              <center><label className="labelPage">Exibindo {page} de {limitPage} registros</label></center>
            </div>
            <button data-tip="Próxima página" type="button" onClick={() => setPage((page + 1) < limitPage ? page + 1 : limitPage)} className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
            <button data-tip="Última página" type="button" onClick={() => setPage(limitPage)} className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight  color="#001675" size={17} /></button>
        </div>
      </div>}
    </div>
  )
}